import { c as _c } from "react/compiler-runtime";
import { alpha, Chip, darken, Skeleton, type SkeletonProps, useTheme } from "@mui/material";
import React from "react";
import type { TopicTag as Topic } from "#/graphql/generated";
import { getTagColors } from "#/shared/lib/tagColors";
interface TopicTagProps {
  topic: Partial<Topic>;
}
export const TopicTag: React.FC<TopicTagProps> = t0 => {
  const $ = _c(21);
  const {
    topic
  } = t0;
  const theme = useTheme();
  let T0;
  let colors;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== theme.palette.primary.contrastText || $[1] !== topic.name || $[2] !== topic.slug) {
    colors = getTagColors(topic.slug);
    const handleClick = _temp;
    T0 = Chip;
    t3 = topic.name;
    t4 = "filled";
    t5 = handleClick;
    if ($[10] !== theme.palette.primary.contrastText) {
      t2 = alpha(theme.palette.primary.contrastText, 0.9);
      $[10] = theme.palette.primary.contrastText;
      $[11] = t2;
    } else {
      t2 = $[11];
    }
    t1 = darken(colors[0], 0.4);
    $[0] = theme.palette.primary.contrastText;
    $[1] = topic.name;
    $[2] = topic.slug;
    $[3] = T0;
    $[4] = colors;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    T0 = $[3];
    colors = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
  }
  const t6 = `linear-gradient(55deg, ${t1} 0%, ${colors[1]} 100%)`;
  let t7;
  if ($[12] !== t2 || $[13] !== t6) {
    t7 = {
      color: t2,
      background: t6,
      fontWeight: "bold",
      letterSpacing: "1px",
      lineHeight: "2rem"
    };
    $[12] = t2;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== T0 || $[16] !== t3 || $[17] !== t4 || $[18] !== t5 || $[19] !== t7) {
    t8 = <T0 label={t3} variant={t4} onClick={t5} sx={t7} />;
    $[15] = T0;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
};
export const TopicTagSkeleton: React.FC<SkeletonProps> = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      borderRadius: 4
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Skeleton height="28px" width="12%" variant="rectangular" sx={t0} {...props} />;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
function _temp() {}